import { Stack, Typography } from '@mui/material';

export interface AuthHeaderProps {
  title: string;
  subtitle?: string;
}

/** The per-screen title/subtitle rendered inside `AuthLayout`'s card — the layout itself only
 * shows the generic "WillnQ" brand heading above this. */
export function AuthHeader({ title, subtitle }: AuthHeaderProps) {
  return (
    <Stack spacing={0.5} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" component="h2" fontWeight={600}>
        {title}
      </Typography>
      {subtitle ? (
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      ) : null}
    </Stack>
  );
}
